import VMSConstants from "@/constants";

export const useImageConstants = () => {
  return VMSConstants.images;
};
